import { render, staticRenderFns } from "./Like.vue?vue&type=template&id=292f8218&"
import script from "./Like.vue?vue&type=script&lang=ts&"
export * from "./Like.vue?vue&type=script&lang=ts&"
import style0 from "./Like.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports